import {CreateUpdateCustomFieldApiDto, CustomFieldApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";

export default class CustomField {
	constructor(public readonly id: string,
		public readonly fieldType: CustomFieldType,
		public readonly label: string,
		public readonly disabledInWorkspace: boolean,
		public readonly disabledInUi: boolean,
		public readonly options: string[]) {}

	static fromJson(json: CustomFieldApiDto): CustomField {
		return new CustomField(json.id, json.fieldType, json.label, json.disabledInWorkspace, json.disabledInUi, json.options);
	}

	toJson(): CreateUpdateCustomFieldApiDto {
		const json: CreateUpdateCustomFieldApiDto = {
			fieldType: this.fieldType,
			label: this.label,
			disabledInWorkspace: this.disabledInWorkspace,
			disabledInUi: this.disabledInUi,
			options: this.options
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({
		id = this.id,
		fieldType = this.fieldType,
		label = this.label,
		disabledInWorkspace = this.disabledInWorkspace,
		disabledInUi = this.disabledInUi,
		options = this.options
	}) {
		return new CustomField(id, fieldType, label, disabledInWorkspace, disabledInUi, options);
	}
}

export enum CustomFieldType {
	STRING = 'STRING',
	BOOLEAN = 'BOOLEAN',
	ENUM = 'ENUM',
	DATE = 'DATE'
}